import { render, staticRenderFns } from "./ThemeCategory.vue?vue&type=template&id=4880c14c&scoped=true&"
import script from "./ThemeCategory.vue?vue&type=script&lang=ts&"
export * from "./ThemeCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880c14c",
  null
  
)

export default component.exports